var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      this.preloader
        ? _c(
            "div",
            { staticClass: "text-xs-center" },
            [
              _c("v-progress-circular", {
                attrs: {
                  size: 70,
                  width: 7,
                  color: "primary",
                  indeterminate: ""
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !this.preloader && this.order
        ? _c(
            "v-container",
            { staticClass: "box", attrs: { fluid: "", "grid-list-md": "" } },
            [
              _c(
                "div",
                { staticClass: "title header" },
                [
                  _vm._v("\n      PEDIDO\n      "),
                  _c("Events", { attrs: { events: this.order.events } })
                ],
                1
              ),
              _vm._v(" "),
              _c("OrderDetails", {
                attrs: { order: this.order },
                on: {
                  refresh: function($event) {
                    return _vm.reloadOrder()
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !this.preloader && this.order
        ? _c(
            "v-container",
            { staticClass: "box", attrs: { fluid: "", "grid-list-md": "" } },
            [
              this.payments.length > 0
                ? _c("div", { staticClass: "title" }, [_vm._v("PAGAMENTOS")])
                : _vm._e(),
              _vm._v(" "),
              this.payments.length > 0
                ? _c("OrderPayments", { attrs: { payments: this.payments } })
                : _vm._e(),
              _vm._v(" "),
              this.payments.length <= 0
                ? _c("div", { staticClass: "title" }, [
                    _vm._v("\n      NENHUM PAGAMENTO REGISTRADO\n    ")
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e5be54c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e5be54c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Orders/ShowOrder/Index.vue
// module id = null
// module chunks = 